// extracted by mini-css-extract-plugin
module.exports = {"btn-primary":"_mobileNoteModal_btn-primary__36o7f","mobile-cancel-purchase":"_mobileNoteModal_mobile-cancel-purchase__2xuMB","title":"_mobileNoteModal_title__2p6IS"};